var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpperZ(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 61,
    viewBox: "0 0 40 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.37997 60.7062V59.2062H6.37997V60.7062H1.37997ZM12.38 60.6962V59.1962H17.38V60.6962H12.38ZM23.38 60.6962V59.1962H28.38V60.6962H23.38ZM34.38 60.6862V59.1862H39.38V60.6862H34.38ZM3.87997 56.1362L2.62997 55.3162L5.36996 51.1362L6.61996 51.9562L3.87997 56.1362ZM9.91998 46.9462L8.66998 46.1262L11.41 41.9462L12.66 42.7662L9.91998 46.9462ZM15.96 37.7462L14.71 36.9262L17.45 32.7462L18.7 33.5662L15.96 37.7462ZM22 28.5462L20.75 27.7262L23.49 23.5462L24.74 24.3662L22 28.5462ZM28.04 19.3462L26.79 18.5262L29.53 14.3462L30.78 15.1662L28.04 19.3462ZM34.08 10.1462L32.83 9.32619L35.57 5.14619L36.82 5.96619L34.08 10.1462ZM0.959961 1.64619V0.146194H5.95996V1.64619H0.959961ZM11.96 1.62619V0.12619H16.96V1.62619H11.96ZM22.96 1.60619V0.106186H27.96V1.60619H22.96ZM33.96 1.58618V0.0861816H38.96V1.58618H33.96Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpperZ);
export default __webpack_public_path__ + "static/media/UPPER_Z.dc03cfcdb657b416f2ac5d30b5cef5b2.svg";
export { ForwardRef as ReactComponent };